import React, {useEffect, useState} from "react";
import { ReactComponent as CloseIcon } from "../../.././../../assets/svg/solobuilder/close-icon.svg";

interface Iprops{
    visibility: boolean;
    setVisibility: (val: boolean) => void;
    setValue: (val: any) => void;
    value: any;
    label: string;
    ConditionsChanges?: (val: any) => void
    idx?: any;
}

export const TextArea = (props: Iprops) => {
    const { setValue, value, label, setVisibility, ConditionsChanges, idx} = props
    const [error, setError] = useState(false)
    const [textValue, setTextValue] = useState("")

    useEffect(() => {
        if(value.val){
            setTextValue(value.val)
        }
        document.addEventListener('keydown', detectKeyDown)
        return () => {
          document.removeEventListener('keydown', detectKeyDown);
        }
    },[])

      const detectKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Escape") {
            setVisibility(false);
        }
      }

    return (
        <div className="custom-color" style={{height: 266, width: 240, bottom: 10}}>
            <div className="w-full h-10 flex justify-between items-center"
                style={{
                    background: "#EFF0F4",
                    padding: "0px 10px"
                }}
            >
                <div style={{fontSize: "12px", fontWeight: 600}}>{label}</div>
                <CloseIcon
                    className="cursor-pointer"
                    onClick={() => {setVisibility(false)}}
                ></CloseIcon>
            </div>
            <div style={{padding: 10}}>
                <textarea
                    value={textValue}
                    defaultValue={textValue}
                    style={{ height: 150, width: "100%", borderRadius: 2, border: error ? "1px solid #dc3545" : "1px solid rgba(125, 132, 146, 0.294)", outline: "none", padding: 10, textAlign: "justify" }}
                    onChange={(e: any) => {
                        if(e.target.value.length <= 500){
                            setTextValue(e.target.value)
                            setError(false)
                        } else {
                            setError(true)}
                        }
                    }     
                />
                <div style={{ fontSize: 10, color: error ? "#dc3545" : "#282b31"}}>{"(Maximum 500 characters only allowed)"}</div>
            </div>
            <div className="flex flex-row  justify-end" style={{padding: 10}}>
                <button onClick={(() => {setVisibility(false)})}
                    style={{
                        outline: "none", background: "none", fontSize: "11px",
                        color: "#969BA5", width: "60px", height: "24px", cursor: "pointer", fontWeight: 700
                    }}>CANCEL</button>
                <button onClick={(() => {
                    setError(false)
                    if(!idx){
                        setValue((prevState: any) => ({
                            ...prevState,
                            desc: textValue
                        }))
                        setVisibility(false);
                    }else{
                       ConditionsChanges && ConditionsChanges({ type: "desc", value: textValue, idx: value.id })
                        setVisibility(false);
                    }
                })} type="button"
                    style={{
                        outline: "none", background: "#052f35 ", fontSize: "11px",
                        borderRadius: "50px", width: "60px", height: "24px",
                        color: "white", cursor: "pointer", fontWeight: 700
                    }}>SUBMIT</button>
            </div>
        </div>
    )
}